import { ApiNotificacao } from "./api-notificacao";
import { NegocioJuridicoRealizado } from "./negocio-juridico-realizado";

export class NegocioJuridicoRealizadoResult {
    success: boolean;
    data: NegocioJuridicoRealizado;
    notifications: ApiNotificacao[];
    errors: string[];

    constructor(values: Object = {}) {
        Object.assign(this, values);
    }
}
